import FormItem from "../../components/Form/FormItem/FormItem";
import Icon from "../../components/Icon/Icon";
import {useState} from "react";
import FormButton from "../../components/Form/Button/FormButton";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";

export default function GetUserInfo({className, onComplete, ...props}) {
    const [error, setError] = useState({});
    const [form, setForm] = useState({
        email: "",
    });
    const [loading, setLoading] = useState(false);

    function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        setError({})
        axiosInstance.post(URLS.CreateCouponPaymentIntent, form).then((res) => {
            let data = res?.data;
             onComplete(data);

        }).catch((err) => {
            if (err?.response?.status === 400) {
                setError(err?.response?.data);
            } else {
                setError({
                    email: "Something went wrong, please try again later."
                })
            }
        }).finally(() => setLoading(false))
    }

    return (
        <form onSubmit={handleSubmit} className={` ${className} flex flex-col gap-3`}>
            <p className={"font-semibold text-center text-2xl "}>
                Enter your email
            </p>

            <FormItem
                LeftIcon={<Icon src={"/icons/email.svg"} className={"w-5 h-5"}/>}
                label={"Email"}
                type={"error"}
                className={"mb-2"}
                message={error?.email}
                variant={"auth"}
            >
                <input
                    type="email"
                    name="email"
                    id="email"
                    value={form.email}
                    onChange={(e) => {
                        setForm({
                            ...form,
                            email: e.target.value
                        })
                    }}
                    required
                    placeholder="Email"
                />


            </FormItem>

            <div className={"flex flex-col justify-center items-center"}>
                <FormButton
                    loading={loading}
                    type={"submit"}
                >
                    Next
                </FormButton>
            </div>

        </form>

    )
}